import { render } from "./P006.vue?vue&type=template&id=b9bd860e&scoped=true"
import script from "./P006.vue?vue&type=script&lang=js"
export * from "./P006.vue?vue&type=script&lang=js"

import "./P006.vue?vue&type=style&index=0&id=b9bd860e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9bd860e"]])

export default __exports__